import { render, staticRenderFns } from "./OIDC.vue?vue&type=template&id=2f6b9150&"
import script from "./OIDC.vue?vue&type=script&lang=ts&"
export * from "./OIDC.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports